import React, { createContext, useContext, useState, useCallback } from "react";

const STRINGS = {
  en: {
    "brand.name": "The Great Indian Dream",
    "brand.tag": "A free, national registry of verified NGOs",
    "nav.discover": "Discover NGOs",
    "nav.stories": "Stories",
    "nav.forCsr": "For CSR Teams",
    "nav.forNgos": "For NGOs",
    "nav.verification": "How we verify",
    "nav.about": "About",
    "nav.faq": "FAQ",
    "nav.contact": "Contact us",
    "nav.dashboard": "Dashboard",
    "nav.workspace": "CSR Workspace",
    "nav.console": "Admin Console",
    "common.login": "Log in",
    "common.register": "Sign up",
    "common.logout": "Log out",
    "common.search": "Search",
    "common.near_me": "Near me",
    "common.list": "List",
    "common.map": "Map",
    "common.filters": "Filters",
    "common.clear": "Clear all",
    "common.loading": "Loading…",
    "common.contact": "Contact Directly",
    "common.download_pack": "Download Due-Diligence Pack",
    "common.view_profile": "View profile",
    "hero.title": "Find the people already doing the work.",
    "hero.title_ta": "ஏற்கனவே பணியில் இருப்பவர்களைக் கண்டறியுங்கள்.",
    "hero.sub": "A free, public directory of verified NGOs and grassroots initiatives across India. Search by cause. Search by district. Check their credentials. Then contact them directly — no middleman, no commission, no money passing through us.",
    "hero.cta1": "Explore NGOs near me",
    "hero.cta2": "I'm a CSR team",
    "hero.search_ph": "Search a cause, an NGO, or a district — try \"water bodies, Erode\"",
    "trust.ngos": "Verified NGOs listed",
    "trust.field": "Field-visited & verified",
    "trust.districts": "Kongu districts covered",
    "trust.fees": "Taken in platform fees, ever",
    "how.title": "How this works",
    "how.give_t": "For anyone who wants to give",
    "how.give_b": "Search by what you care about and where you live. Every listing shows exactly which registrations the organisation holds and when they expire. Go visit. Decide for yourself. Give directly to them.",
    "how.csr_t": "For companies with CSR budgets",
    "how.csr_b": "Filter for partners who are actually eligible under the Companies Act — CSR-1 registered, 12A or 10(23C) held, three-year track record. Download a due-diligence pack for your committee. Shortlist in an afternoon instead of a quarter.",
    "how.ngo_t": "For NGOs",
    "how.ngo_b": "List your work for free, permanently. Upload your certificates, photographs and project stories. Get found by people looking for exactly what you already do. We never charge you and never take a share of what you raise.",
    "money.title": "Why we don't touch your money",
    "money.title_ta": "நாங்கள் ஏன் உங்கள் பணத்தைக் கையாள்வதில்லை",
    "money.body": "Not one rupee passes through this platform. There is no donate button here that takes your money. No wallet. No escrow. No processing fee shaved off the top. When you find an organisation you want to support, you contact them and you give to them — directly, into their account, with your 80G receipt coming from them. We are the phone book, not the bank.",
    "cause.title": "Browse by cause",
    "cause.sub": "Human language, not statute. Pick what you care about.",
    "stories.title": "Stories from the field",
    "stories.sub": "Real work, in progress. No pity, no poverty framing — people with agency.",
    "closing.title": "Know an organisation doing good work that isn't listed here?",
    "closing.body": "Tell us about them. We'll verify and add them, free.",
    "closing.cta": "Suggest an NGO",
    "discover.title": "Discover verified NGOs",
    "discover.results": "organisations found",
    "discover.csr_only": "CSR-eligible only",
    "discover.volunteer": "Accepts volunteers",
    "discover.zero": "No matches. Try widening your radius or picking an adjacent cause.",
    "filter.cause": "Cause",
    "filter.district": "District",
    "filter.tier": "Min. verification tier",
    "filter.credential": "Credential held",
    "filter.budget": "Budget band",
    "filter.any": "Any",
    "footer.dpo": "Data Protection Officer",
    "footer.rights": "No money moves through this platform. No listing fee, no donor fee, no commission — ever.",
    "eligible.yes": "CSR-eligible",
    "eligible.no": "Not CSR-eligible directly",
  },
  ta: {
    "brand.name": "The Great Indian Dream",
    "brand.tag": "சரிபார்க்கப்பட்ட என்.ஜி.ஓ-க்களின் தேசிய பதிவேடு",
    "nav.discover": "என்.ஜி.ஓ கண்டறிதல்",
    "nav.stories": "கதைகள்",
    "nav.forCsr": "CSR குழுக்களுக்கு",
    "nav.forNgos": "என்.ஜி.ஓ-க்களுக்கு",
    "nav.verification": "சரிபார்ப்பு முறை",
    "nav.about": "எங்களைப் பற்றி",
    "nav.faq": "கேள்விகள்",
    "nav.contact": "தொடர்பு கொள்ள",
    "nav.dashboard": "டாஷ்போர்டு",
    "nav.workspace": "CSR பணியிடம்",
    "nav.console": "நிர்வாக மையம்",
    "common.login": "உள்நுழை",
    "common.register": "பதிவு செய்",
    "common.logout": "வெளியேறு",
    "common.search": "தேடு",
    "common.near_me": "அருகில்",
    "common.list": "பட்டியல்",
    "common.map": "வரைபடம்",
    "common.filters": "வடிகட்டிகள்",
    "common.clear": "அனைத்தையும் அழி",
    "common.loading": "ஏற்றுகிறது…",
    "common.contact": "நேரடியாக தொடர்பு கொள்",
    "common.download_pack": "சரிபார்ப்பு ஆவணத் தொகுப்பு",
    "common.view_profile": "விவரம் காண்",
    "hero.title": "ஏற்கனவே பணியில் இருப்பவர்களைக் கண்டறியுங்கள்.",
    "hero.title_ta": "",
    "hero.sub": "இந்தியா முழுவதும் சரிபார்க்கப்பட்ட என்.ஜி.ஓ-க்கள் மற்றும் அடிமட்ட முயற்சிகளின் இலவச பொது அடைவு. காரணத்தால் தேடுங்கள். மாவட்டத்தால் தேடுங்கள். அவர்களின் சான்றுகளைச் சரிபார்க்கவும். பிறகு நேரடியாக அவர்களைத் தொடர்பு கொள்ளுங்கள் — இடைத்தரகர் இல்லை, கமிஷன் இல்லை.",
    "hero.cta1": "அருகில் உள்ள என்.ஜி.ஓ-க்கள்",
    "hero.cta2": "நான் ஒரு CSR குழு",
    "hero.search_ph": "காரணம், என்.ஜி.ஓ அல்லது மாவட்டம் தேடுங்கள் — \"நீர் நிலைகள், ஈரோடு\"",
    "trust.ngos": "சரிபார்க்கப்பட்ட என்.ஜி.ஓ-க்கள்",
    "trust.field": "நேரில் கள ஆய்வு செய்யப்பட்டது",
    "trust.districts": "கொங்கு மாவட்டங்கள்",
    "trust.fees": "தள கட்டணம் — என்றும் இல்லை",
    "how.title": "இது எப்படி வேலை செய்கிறது",
    "how.give_t": "கொடுக்க விரும்புவோருக்கு",
    "how.give_b": "நீங்கள் அக்கறை கொள்வதையும் வசிக்கும் இடத்தையும் கொண்டு தேடுங்கள். ஒவ்வொரு பட்டியலும் அமைப்பு வைத்திருக்கும் பதிவுகளையும் அவற்றின் காலாவதி தேதிகளையும் காட்டுகிறது. நேரில் சென்று பாருங்கள். நேரடியாக கொடுங்கள்.",
    "how.csr_t": "CSR நிதி உள்ள நிறுவனங்களுக்கு",
    "how.csr_b": "நிறுவனச் சட்டத்தின் கீழ் உண்மையில் தகுதியுள்ள கூட்டாளர்களை வடிகட்டுங்கள் — CSR-1, 12A அல்லது 10(23C), மூன்று ஆண்டு அனுபவம். உங்கள் குழுவிற்கான ஆவணத் தொகுப்பைப் பதிவிறக்கவும்.",
    "how.ngo_t": "என்.ஜி.ஓ-க்களுக்கு",
    "how.ngo_b": "உங்கள் பணியை இலவசமாக, நிரந்தரமாக பட்டியலிடுங்கள். உங்கள் சான்றிதழ்கள், புகைப்படங்கள், கதைகளைப் பதிவேற்றுங்கள். நாங்கள் எப்போதும் கட்டணம் வசூலிப்பதில்லை.",
    "money.title": "நாங்கள் ஏன் உங்கள் பணத்தைக் கையாள்வதில்லை",
    "money.title_ta": "",
    "money.body": "இந்த தளத்தின் வழியாக ஒரு ரூபாய் கூட செல்வதில்லை. பணத்தைப் பெறும் நன்கொடை பொத்தான் இங்கு இல்லை. நீங்கள் நேரடியாக அமைப்பின் கணக்கிற்கு கொடுக்கிறீர்கள், 80G ரசீது அவர்களிடமிருந்தே வரும். நாங்கள் தொலைபேசி புத்தகம், வங்கி அல்ல.",
    "cause.title": "காரணத்தால் உலாவுக",
    "cause.sub": "சட்ட விதி அல்ல, மனித மொழி. நீங்கள் அக்கறை கொள்வதைத் தேர்வு செய்யுங்கள்.",
    "stories.title": "களத்திலிருந்து கதைகள்",
    "stories.sub": "உண்மையான பணி, நடந்துகொண்டிருக்கிறது.",
    "closing.title": "இங்கே பட்டியலிடப்படாத நல்ல பணி செய்யும் அமைப்பு தெரியுமா?",
    "closing.body": "எங்களிடம் சொல்லுங்கள். நாங்கள் சரிபார்த்து இலவசமாக சேர்ப்போம்.",
    "closing.cta": "என்.ஜி.ஓ பரிந்துரை",
    "discover.title": "சரிபார்க்கப்பட்ட என்.ஜி.ஓ-க்கள்",
    "discover.results": "அமைப்புகள் கிடைத்தன",
    "discover.csr_only": "CSR தகுதியுள்ளவை மட்டும்",
    "discover.volunteer": "தன்னார்வலர்களை ஏற்கும்",
    "discover.zero": "பொருத்தம் இல்லை. வரம்பை விரிவாக்கவும்.",
    "filter.cause": "காரணம்",
    "filter.district": "மாவட்டம்",
    "filter.tier": "குறைந்தபட்ச சரிபார்ப்பு",
    "filter.credential": "சான்று",
    "filter.budget": "நிதி வரம்பு",
    "filter.any": "எதுவும்",
    "footer.dpo": "தரவு பாதுகாப்பு அதிகாரி",
    "footer.rights": "இந்த தளத்தின் வழியாக பணம் நகராது. கட்டணம் இல்லை, கமிஷன் இல்லை — என்றும்.",
    "eligible.yes": "CSR தகுதி",
    "eligible.no": "நேரடி CSR தகுதி இல்லை",
  },
  hi: {
    "brand.name": "The Great Indian Dream",
    "brand.tag": "सत्यापित एनजीओ की राष्ट्रीय, निःशुल्क निर्देशिका",
    "nav.discover": "एनजीओ खोजें",
    "nav.stories": "कहानियाँ",
    "nav.forCsr": "CSR टीमों के लिए",
    "nav.forNgos": "एनजीओ के लिए",
    "nav.verification": "हम कैसे सत्यापित करते हैं",
    "nav.about": "हमारे बारे में",
    "nav.faq": "सामान्य प्रश्न",
    "nav.contact": "संपर्क करें",
    "nav.dashboard": "डैशबोर्ड",
    "nav.workspace": "CSR कार्यक्षेत्र",
    "nav.console": "प्रशासन कंसोल",
    "common.login": "लॉग इन",
    "common.register": "साइन अप",
    "common.logout": "लॉग आउट",
    "common.search": "खोजें",
    "common.near_me": "मेरे पास",
    "common.list": "सूची",
    "common.map": "नक्शा",
    "common.filters": "फ़िल्टर",
    "common.clear": "सब साफ़ करें",
    "common.loading": "लोड हो रहा है…",
    "common.contact": "सीधे संपर्क करें",
    "common.download_pack": "ड्यू-डिलिजेंस पैक डाउनलोड करें",
    "common.view_profile": "प्रोफ़ाइल देखें",
    "hero.title": "जो लोग पहले से काम कर रहे हैं, उन्हें खोजें।",
    "hero.title_ta": "",
    "hero.sub": "पूरे भारत में सत्यापित एनजीओ और ज़मीनी पहलों की मुफ़्त, सार्वजनिक निर्देशिका। कारण से खोजें। ज़िले से खोजें। उनके प्रमाणपत्र जाँचें। फिर सीधे उनसे संपर्क करें — कोई बिचौलिया नहीं, कोई कमीशन नहीं।",
    "hero.cta1": "मेरे पास के एनजीओ खोजें",
    "hero.cta2": "मैं एक CSR टीम हूँ",
    "hero.search_ph": "कारण, एनजीओ या ज़िला खोजें — \"जल निकाय, इरोड\"",
    "trust.ngos": "सत्यापित एनजीओ सूचीबद्ध",
    "trust.field": "स्थल पर सत्यापित",
    "trust.districts": "कोंगु ज़िले शामिल",
    "trust.fees": "मंच शुल्क, कभी नहीं",
    "how.title": "यह कैसे काम करता है",
    "how.give_t": "जो देना चाहते हैं उनके लिए",
    "how.give_b": "जिसकी आप परवाह करते हैं और जहाँ रहते हैं, उससे खोजें। हर सूची दिखाती है कि संस्था के पास कौन-से पंजीकरण हैं और वे कब समाप्त होते हैं। जाकर देखें। खुद तय करें। सीधे उन्हें दें।",
    "how.csr_t": "CSR बजट वाली कंपनियों के लिए",
    "how.csr_b": "कंपनी अधिनियम के तहत वास्तव में पात्र भागीदारों के लिए फ़िल्टर करें — CSR-1 पंजीकृत, 12A या 10(23C), तीन-वर्ष का ट्रैक रिकॉर्ड। अपनी समिति के लिए ड्यू-डिलिजेंस पैक डाउनलोड करें।",
    "how.ngo_t": "एनजीओ के लिए",
    "how.ngo_b": "अपना काम मुफ़्त, स्थायी रूप से सूचीबद्ध करें। अपने प्रमाणपत्र, तस्वीरें और परियोजना कहानियाँ अपलोड करें। हम कभी शुल्क नहीं लेते।",
    "money.title": "हम आपके पैसे को क्यों नहीं छूते",
    "money.title_ta": "",
    "money.body": "इस मंच से एक रुपया भी नहीं गुज़रता। यहाँ कोई डोनेट बटन नहीं है जो आपका पैसा ले। आप सीधे संस्था के खाते में देते हैं, और 80G रसीद उन्हीं से आती है। हम फ़ोन बुक हैं, बैंक नहीं।",
    "cause.title": "कारण से ब्राउज़ करें",
    "cause.sub": "क़ानूनी धारा नहीं, मानवीय भाषा। जिसकी आप परवाह करते हैं उसे चुनें।",
    "stories.title": "मैदान से कहानियाँ",
    "stories.sub": "असली काम, प्रगति पर।",
    "closing.title": "कोई अच्छा काम करने वाली संस्था जानते हैं जो यहाँ सूचीबद्ध नहीं है?",
    "closing.body": "हमें बताएं। हम सत्यापित करके मुफ़्त में जोड़ देंगे।",
    "closing.cta": "एक एनजीओ सुझाएँ",
    "discover.title": "सत्यापित एनजीओ खोजें",
    "discover.results": "संस्थाएँ मिलीं",
    "discover.csr_only": "केवल CSR-पात्र",
    "discover.volunteer": "स्वयंसेवकों को स्वीकारता है",
    "discover.zero": "कोई मेल नहीं। अपना दायरा बढ़ाएँ।",
    "filter.cause": "कारण",
    "filter.district": "ज़िला",
    "filter.tier": "न्यूनतम सत्यापन स्तर",
    "filter.credential": "प्रमाणपत्र",
    "filter.budget": "बजट श्रेणी",
    "filter.any": "कोई भी",
    "footer.dpo": "डेटा संरक्षण अधिकारी",
    "footer.rights": "इस मंच से पैसा नहीं गुज़रता। कोई शुल्क नहीं, कोई कमीशन नहीं — कभी नहीं।",
    "eligible.yes": "CSR-पात्र",
    "eligible.no": "सीधे CSR-पात्र नहीं",
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("thadam_lang") || "en");
  const switchLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("thadam_lang", l);
  }, []);
  const t = useCallback((key) => (STRINGS[lang] && STRINGS[lang][key]) || STRINGS.en[key] || key, [lang]);
  return <LangContext.Provider value={{ lang, switchLang, t }}>{children}</LangContext.Provider>;
}

export function useT() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useT must be used within LanguageProvider");
  return ctx;
}
